<template>
	<div class="title-box">
		<HeaderTab />
	</div>
	<div class="proposals">
		<div class="proposals-wrap">
			<!-- <NewsWeekly /> -->
			<div class="filter">
				<FilterProposal
					@changePageToFirst="
						$refs['listProposal'].changePageToFirst()
					"
				/>
				<button class="submit-proposal" @click="submitProposal()">
					Submit a proposal
				</button>
			</div>
			<ListProposal ref="listProposal" />
		</div>
	</div>
	<div :class="{ 'm-bottom-110': windowSize <= 800 }">
		<Foot :theme="'white'" />
	</div>
</template>

<script>
import FilterProposal from '@/components/Proposals/FilterProposal.vue'
import ListProposal from '@/components/Proposals/ListProposal.vue'
import NewsWeekly from '@/components/Proposals/NewsWeekly.vue'
import Foot from '@/components/FOOT.vue'
import HeaderTab from '@/components/HeaderTab.vue'

export default {
	name: 'Dao',
	components: {
		FilterProposal,
		ListProposal,
		NewsWeekly,
		Foot,
		HeaderTab
	},
	data() {
		return {
			windowSize: window.innerWidth,
			categorySelected: undefined,
		}
	},
	mounted() {
		// if(this.$route.path.includes('dao') && Object.keys(this.$route.query).length == 0) {
		// 	this.mxShowMainNotiModal({
		// 		isShow: true,
		// 		type: 'dao'
		// 	})
		// }
	},
	methods: {
		submitProposal() {
			this.$router.push({ path: 'submit' })
		},
	},
}
</script>

<style lang="scss" scoped>
.title-box {
	@include FLEXV(flex-start, center);
	width: 100%;
	height: gREm(204);
	background-image: url('../assets/img/dao/header-bg.png');
	background-repeat: no-repeat;
	background-size: cover;
	.title-wrap {
		@include FLEXV(center, center);
		width: auto;
		height: gREm(95);
		margin-top: gREm(215);
		.title {
			height: auto;
			width: gREm(322);
			@include Set-Font($AppFont, gREm(34), gREm(52), #ffffff, 600);
			text-align: center;
		}
		.sub-title {
			height: auto;
			width: auto;
			@include Set-Font($AppFont, gREm(34), gREm(52), #ffffff);
			text-align: center;
		}
	}
}

.proposals {
	font-family: 'Montserrat';
	background: white;
	min-height: calc(100vh - 144px - 250px);
	.proposals-wrap {
		display: flex;
		gap: 20px;
		width: 100%;
		max-width: 1180px;
		height: auto;
		margin: 0 auto;
		padding-top: 20px;
		padding-bottom: 20px;
		.submit-proposal {
			display: none;
		}
	}
}
.m-bottom-110 {
	margin-bottom: 110px;
}

@include media-max($media_large) {
	// 1200
}

@include media-max($media_medium) {
	// 1024
	.proposals-wrap {
		padding: 20px;
	}
}

@include media-max(800px) {
	.filter {
		position: fixed;
		z-index: 8;
		bottom: 0;
		left: 0;
		background: #fff;
		width: 100vw;
		padding: 15px;
		box-shadow: 0px 0 10px rgba(183, 181, 181, 0.8);
	}
	.submit-proposal {
		display: block !important;
		background: #6c38ef;
		font-size: 14px;
		padding: 5px 15px;
		border-radius: 4px;
		color: #f9fafb;
		background: #6c38ef;
		font-family: 'Montserrat';
		width: 100%;
		height: 34px;
		margin-top: 15px;
	}
	.proposals {
		.proposals-wrap {
			padding: 20px 0;
			flex-direction: column;
		}
	}
}
</style>
